<template>
  <div>
    <div v-if="showAnimation" style="height: 300px">
      <loading-animation @loopComplete="loadAnimationComplete"></loading-animation>
    </div>
    <div v-show="!showAnimation">
      <div :id="idChart"></div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import LoadingAnimation from "../LoadingAnimation";
import Highcharts from "highcharts";
import Exporting from "highcharts/modules/export-data";
import Accessibility from "highcharts/modules/accessibility";
Accessibility(Highcharts);
Exporting(Highcharts);
export default {
  name: "RainEstimationHistoricalDataChart",
  components: {
    LoadingAnimation,
  },
  props: {
    series: {
      required: true,
    },
    searchResult: {
      required: true,
    },
    description: {
      required: true,
    },
    caption: {
      required: true,
    },
  },
  data: () => ({
    idChart: "chartContainer",
    chartRendered: undefined,
    showAnimation: false,
    loading: false,
  }),

  mounted() {
    this.initialize();
  },

  watch: {
    searchResult(value) {
      if (value) {
        this.initialize();
      }
    },
  },

  methods: {
    initialize() {
      this.loading = true;
      this.showAnimation = true;
      this.chartPreprocessing();
    },
    chartPreprocessing() {
      let chart = document.getElementById(this.idChart);
      if (this.series) {
        this.dataSource(chart, this.series, this.accessibility, this.caption);
        this.loading = false;
        chart.style.visibility = "visible";
        chart.style.display = "block";
      } else {
        chart.style.visibility = "hidden";
        chart.style.display = "none";
      }
      this.$emit("chartRenderComplete", this.chartRendered);
    },
    loadAnimationComplete() {
      this.showAnimation = this.loading;
    },
    async dataSource(elementId, series, description, caption) {
      let Dateformat = this.dateFormatted();
      Highcharts.setOptions({
        lang: {
          months: [
            "Janeiro",
            "Fevereiro",
            "Março",
            "Abril",
            "Maio",
            "Junho",
            "Julho",
            "Agosto",
            "Setembro",
            "Outubro",
            "Novembro",
            "Dezembro",
          ],
          shortMonths: [
            "Jan",
            "Fev",
            "Mar",
            "Abr",
            "Mai",
            "Jun",
            "Jul",
            "Ago",
            "Set",
            "Out",
            "Nov",
            "Dez",
          ],
          weekdays: [
            "Domingo",
            "Segunda",
            "Terça",
            "Quarta",
            "Quinta",
            "Sexta",
            "Sábado",
          ],
        },
      }),
        (this.chartRendered = Highcharts.chart({
          colors: ["#95A1EC", this.$vuetify.theme.themes.dark.primary.base],
          colorAxis: {
            gridLineColor: this.$vuetify.theme.themes.dark.primary.darken1,
          },
          chart: {
            renderTo: elementId,
            backgroundColor: this.$vuetify.theme.themes.dark.primary.darken1,
          },
          plotOptions: {
            column: {
              borderWidth: 0,
            },
          },
          exporting: {
            enabled: false,
            filename: `dados-históricos-de-estimativa-de-chuva-e-vazão  - ${this.searchResult.type} - ${this.searchResult.location.text}`,
            sourceWidth: 1000,
            chartOptions: {
              title: {
                text: `Dados Históricos de Estimativa de Chuva e Vazão - ${
                  this.searchResult.type
                } - ${this.searchResult.location ? this.searchResult.location.text : ""}`,
                style: {
                  color: "#FFFFFF",
                },
              },
              subtitle: {
                text: "",
                style: {
                  color: "#FFFFFF",
                },
              },
            },
          },
          title: {
            text: "",
          },
          credits: {
            enabled: true,
            href: "https://www.simepar.br/",
            text: "by: SIMEPAR",
            style: {
              color: "#FFFFFF",
            },
          },
          legend: {
            enabled: true,
            itemStyle: {
              color: "#FFFFFF",
            },
            itemHoverStyle: {
              color: "#979797",
            },
          },
          xAxis: {
            accessibility:{
              description: description
            },
            // gridLineWidth: 1,
            // gridLineColor: "#2D324F",
            tickColor: "#2D324F",
            tickWidth: 2,
            lineWidth: 2,
            lineColor: "#2D324F",
            type: "datetime",
            ordinal: false,
            crosshair: {
              enabled: true,
            },
            labels: {
              format:
                this.searchResult.type === "diario"
                  ? "{value:%d/%m/%y}"
                  : this.searchResult.type === "mensal"
                  ? "{value:%b/%y}"
                  : this.searchResult.type === "horario"
                  ? ""
                  : "",
              style: {
                color: "#FFFFFF",
              },
            },
          },
          yAxis: [
            {
              min: 0,
              height: '45%',
              tickColor: '#2D324F',
              tickWidth: 2,
              lineWidth: 2,
              lineColor: '#2D324F',
              gridLineWidth: 2,
              gridLineColor:'#2D324F',
              title: series[0].title,
              labels: {
                format: '{value}',
                style: {
                  color: '#FFFFFF'
                }
              },
              accessibility: {
                description: series[0].title,
              },
              reversed: true,
              opposite: false,
            },
            {
              min: 0,
              top: '55%',
              height: '45%',
              offset: 0,
              tickColor: '#2D324F',
              tickWidth: 2,
              lineWidth: 2,
              lineColor: '#2D324F',
              gridLineWidth: 2,
              gridLineColor:'#2D324F',
              title: series[1].title,
              labels: {
                format: '{value}',
                style: {
                  color: '#FFFFFF'
                }
              },
              accessibility: {
                description: series[1].title,
              },
              reversed: false,
              opposite: false,
            },
            // {
            //   type: "numeric",
            //   min: 0,
            //   title: {
            //     text: "Precipitação (mm) Total",
            //     style: {
            //       color: "#FFFFFF",
            //     },
            //   },
            //   accessibility: {
            //     description: "Precipitação (mm) Total",
            //   },
            //   labels: {
            //     format: "{value}",
            //     style: {
            //       color: "#FFFFFF",
            //     },
            //   },
            //   lineWidth: 2,
            //   lineColor: "#2D324F",
            //   gridLineWidth: 1,
            //   gridLineColor: "#2D324F",
            //   resize: {
            //     enabled: true,
            //   },
            //   reversed: true,
            //   opposite: false,
            // },
          ],
          tooltip: {
            formatter: function () {
              return this.points.reduce(function (s, point) {
                return s + '<br/>' + '<strong style="color:' + point.series.color + '">' +point.series.name + ': ' + '</strong>'+
                  '<b>' + (point.y).toFixed(point.series.tooltipOptions.valueDecimals) + point.series.tooltipOptions.valueSuffix +'</b>';
              }, '<b style="text-transform: capitalize">' + moment.utc(this.x).locale('pt-br').format(Dateformat) + '</b>');
            },
            shared: true,
            crosshairs: true
          },
          series: series,
          caption: caption,
          responsive: {
            rules: [
              {
                condition: {
                  maxWidth: 500,
                },
                chartOptions: {
                  legend: {
                    layout: "horizontal",
                    align: "center",
                    verticalAlign: "bottom",
                  },
                },
              },
            ],
          },
        }));
    },
    dateFormatted() {
      let x;
      let type = this.searchResult.type;
      if (type === "diario") {
        x = "dddd, DD/MM/YYYY";
      } else if (type === "mensal") {
        x = "MMMM, YYYY";
      } else if (type === "Hoje" || type === "Amanhã") {
        x = "dddd, DD/MM/YYYY HH:mm";
      }
      return x;
    },
  },
};
</script>

<style></style>
